/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createExp } from '../../factoriesAny.js';
export var expDependencies = {
  typedDependencies: typedDependencies,
  createExp: createExp
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesExp.generated.js
// module id = 1539
// module chunks = 0